import { Component, OnInit, ViewChild } from '@angular/core';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { NzTableQueryParams } from 'ng-zorro-antd/table';
import { moduleMaster } from 'src/app/Models/BasicForms/moduleMaster';
import { ApiService } from 'src/app/Service/api.service';
import { ModuleFeatureViewComponent } from '../../ModuleFeatureView/module-feature-view/module-feature-view.component';
import { ModuleMappingComponent } from '../module-mapping/module-mapping.component';

@Component({
  selector: 'app-module-master',
  templateUrl: './module-master.component.html',
  styleUrls: ['./module-master.component.css']
})

export class ModuleMasterComponent implements OnInit {
  constructor(public _apiService: ApiService, private notificationService: NzNotificationService) { }

  formTitle = "Modules";
  roadmaptrue=false


  ngOnInit(): void {
    this.filterIsAppliedOrNot();
    this.loadAllProjects();

    this.logtext = 'OPENED - Module Master form KEYWORD[O - Module Master] ';
    this._apiService.addLog('A', this.logtext, this._apiService.emailId).subscribe(successCode => {
      if (successCode['code'] == "200") {

      }
      else {

      }
    });
  }

  projectID = [];
  projectList = [];
  loadAllProjects() {
    this._apiService.getAllProjects(0, 0, 'ID', 'desc', '').subscribe(projectData => {
      this.projectList = projectData['data'];

    }, err => {

    });
  }

  displayFilterBox = false;
  flterBoxVisibleInvisible() {
    this.displayFilterBox = !this.displayFilterBox;
  }

  filterButtonType = "default";

  filterIsAppliedOrNot() {
    if (this.projectID.length > 0) {

      this.filterButtonType = "primary";

    } else {
      this.filterButtonType = "default";
    }
  }

  pageIndex = 1;
  pageSize = 10;
  totalRecords = 1;
  sortValue: string = "desc";
  logtext: string = "";
  searchText: string = "";
  columns: string[][] = [["PROJECT_NAME", "Project"], ["NAME", "Module"], ["DESCRIPTION", "Description"], ["ESTIMATED_MANDAYS", "E Mandays"]];
  filterQuery: string = "";
  isloadSpinning = false;
  loadingRecords = false;
  moduleData = [];

  getAllModules(reset: boolean = false) {
    if (reset) {
      this.pageIndex = 1;
    }

    this.loadingRecords = true;
    var sort: string;
    try {
      sort = this.sortValue.startsWith("a") ? "asc" : "desc";
      this.logtext = 'Filter Applied - Module Master form"+ sort +" "+this.sortKey +" KEYWORD [F - Module Master] ';
      this._apiService.addLog('A', this.logtext, this._apiService.emailId).subscribe(successCode => {
        if (successCode['code'] == "200") {

        }
        else {

        }
      });
    } catch (error) {
      sort = "";
    }


    if (this.searchText != "") {
      var likeQuery = " AND";
      this.columns.forEach(column => {
        likeQuery += " " + column[0] + " like '%" + this.searchText + "%' OR";
      });
      likeQuery = likeQuery.substring(0, likeQuery.length - 2)

    }

    this.logtext = 'Filter Applied - Module Master form "+ likeQuery +" KEYWORD [F - Module Master] ';
    this._apiService.addLog('A', this.logtext, this._apiService.emailId).subscribe(successCode => {
      if (successCode['code'] == "200") {

      }
      else {

      }
    });

    this.applyFilter();
    var filter = ""
    if (likeQuery)
      filter = this.filterQuery + likeQuery
    else
      filter = this.filterQuery


    this.isloadSpinning = true

    this._apiService.getAllModules(this.pageIndex, this.pageSize, this.sortKey, sort, filter).subscribe(data => {

      this.loadingRecords = false;
      this.totalRecords = data['count'];
      this.moduleData = data['data'];

    }, err => {

      if (err['ok'] == false)
        this.notificationService.error("Server Not Found", "");
    });
  }

  filterClass: string = "filter-invisible";
  isFilterApplied: string = "default";

  applyFilter() {



    if (this.projectID.length == 0)
      this.filterQuery = ""
    else {
      this.filterQuery = " AND PROJECT_ID in ( " + this.projectID + " )"
      this.isFilterApplied = "primary";
      this.filterClass = "filter-invisible";
    }
  }

  showFilter(): void {
    if (this.filterClass === "filter-visible")
      this.filterClass = "filter-invisible";
    else
      this.filterClass = "filter-visible";
  }

  clearFilter() {
    this.filterQuery = "";
    this.projectID = [];

    this.isFilterApplied = "default";
    this.filterClass = "filter-invisible";

    this.getAllModules();
  }

  drawerVisible = false;
  mappingDrawerVisible = false;
  drawerTitle = "";
  mappingDrawerTitle = "";
  moduleDrawerData: moduleMaster = new moduleMaster();
  showWorkLogsLink = false;

  add() {
    this.drawerTitle = "Create Module";
    this.moduleDrawerData = new moduleMaster();
    this.drawerVisible = true;
    this.showWorkLogsLink = false;
    this.moduleDrawerData.IS_ACTIVE = true;

    this.logtext = 'ADD - Module Master form KEYWORD [A - Module Master] ';
    this._apiService.addLog('A', this.logtext, this._apiService.emailId).subscribe(successCode => {
      if (successCode['code'] == "200") {

      }
      else {

      }
    });
  }

  edit(data: moduleMaster) {
    this.drawerTitle = "Module Details";
    this.moduleDrawerData = Object.assign({}, data);
    this.drawerVisible = true;
    this.showWorkLogsLink = true;

    this.logtext = 'EDIT - Module Master form KEYWORD [E - Module Master] ';
    this._apiService.addLog('A', this.logtext, this._apiService.emailId).subscribe(successCode => {
      if (successCode['code'] == "200") {

      }
      else {

      }
    });
  }

  drawerClose() {
    this.getAllModules();
    this.drawerVisible = false;
    this.showWorkLogsLink = null;
  }

  get callBackDrawerClose() {
    return this.drawerClose.bind(this);
  }

  mappingDrawerClose() {
    this.mappingDrawerVisible = false;
  }

  get callBackMappingDrawerClose() {
    return this.mappingDrawerClose.bind(this);
  }

  moduleMappingDrawerData: [];
  @ViewChild(ModuleMappingComponent) ModuleMappingComponentVar: ModuleMappingComponent;

  mapModule(data: moduleMaster) {
    this.ModuleMappingComponentVar.loadingRecords = true;

    this._apiService.getModuleDetails(data.ID, 1).subscribe(data => {
      this.ModuleMappingComponentVar.loadingRecords = false;

      this.moduleMappingDrawerData = data['data'];

    }, err => {

    });

    this.moduleDrawerData = Object.assign({}, data);
    this.mappingDrawerTitle = data.NAME;
    this.mappingDrawerVisible = true;
    this.ModuleMappingComponentVar.TASK_CATEGORY_ID = 1;
  }

  sortKey: string = "id";
  sort(params: NzTableQueryParams): void {
    const { pageSize, pageIndex, sort } = params;
    const currentSort = sort.find(item => item.value !== null);
    const sortField = (currentSort && currentSort.key) || 'id';
    const sortOrder = (currentSort && currentSort.value) || 'desc';



    this.pageIndex = pageIndex;
    this.pageSize = pageSize;

    if (this.pageSize != pageSize) {
      this.pageIndex = 1;
      this.pageSize = pageSize;
    }

    if (this.sortKey != sortField) {
      this.pageIndex = 1;
      this.pageSize = pageSize;
    }

    this.sortKey = sortField;
    this.sortValue = sortOrder;
    this.getAllModules();
  }

  viewModuleDrawerVisible = false;
  viewModuleDrawerTitle = "";
  type: number;
  typeID: number;
  @ViewChild(ModuleFeatureViewComponent) ModuleFeatureViewComponentVar: ModuleFeatureViewComponent;

  viewModuleDetails(data: moduleMaster) {
    this.viewModuleDrawerTitle = "Module Details";
    this.moduleDrawerData = Object.assign({}, data);
    this.viewModuleDrawerVisible = true;

    this.type = 2;
    this.typeID = data.ID;

    this.ModuleFeatureViewComponentVar.getFeatureModuleIDWise(data.ID);
    this.ModuleFeatureViewComponentVar.getAttachmentIDWise(this.type, data.ID);
    this.ModuleFeatureViewComponentVar.getCommentIDWise(this.type, data.ID);
    this.ModuleFeatureViewComponentVar.getWorklogIDWise(this.type, data.ID);
    this.ModuleFeatureViewComponentVar.getAssignees(data['ASSIGNEE_NAMES']);
    this.ModuleFeatureViewComponentVar.getReporterFromID(data['REPORTER_IDS']);
  }

  viewModuleDetailsDrawerClose() {
    this.getAllModules();
    this.viewModuleDrawerVisible = false;
  }

  onEnterKeyDown() {
    document.getElementById("button1").focus();
    this.getAllModules(true);
  }
}
